// Angular
import { Injectable } from '@angular/core';
import { AppCleanup } from '../models';

// Libraries

@Injectable({
	providedIn: 'root',
})
export class AudioService extends AppCleanup {
	constructor() {
		super();
	}

	playNotificationAudio() {
		let audio = new Audio();
		audio.src = '../../../assets/audio/notification.mp3';
		audio.load();
		audio.play();
	}
}
